import { KeyboardEventHandler } from 'react';

export const handleEnterPress: (submit: () => void) => KeyboardEventHandler = (submit) => (event) => {
  if (event.code === 'Enter') {
    event.stopPropagation();
    submit();
  }
};
